import { Card } from "../../../components/Card";
import { GoalCard } from "./GoalCard";
import { LockWithTooltip } from "./LockWithTooltip";
import { ReactComponent as ClockIcon } from "../../../assets/icons/clock.svg";


function WeeklyGoalsWarning({ weeklyGoalsWarning }: { weeklyGoalsWarning: any }) {
    return (
        <div className="flex mb-2 items-center gap-2 shadow-[0_1px_2px_-1px_rgba(0,0,0,0.10),_0_1px_3px_0_rgba(0,0,0,0.10)] bg-red-50 rounded-[5px] p-3">
            <ClockIcon className="w-6 h-6 [&_path]:stroke-[#DC2626] [&_path]:stroke-[2px]" />
            <div className="text-sm text-black">{weeklyGoalsWarning?.warning_message}</div>
        </div>
    )
}

export function BadgeCenterWeeklyGoals({ isLocked, weeklyGoals, weeklyGoalsWarning }: { isLocked: boolean, weeklyGoals: any, weeklyGoalsWarning: any }) {
    const weeklyGoalsData = weeklyGoals?.weekly_goal ?? {};
    const title = weeklyGoalsData.title ?? "";
    const currentProgress = weeklyGoalsData.current_progress ?? 0;
    const targetProgress = weeklyGoalsData.target_progress ?? 0;
    const isCompleted = weeklyGoalsData.state === "completed";

    return (
        <Card className="!p-[18px]">
            <div className="flex flex-col mb-2">
                <div className="flex items-center gap-1.5">
                    {isLocked ? <LockWithTooltip /> : <></>}
                    <span className="text-base font-semibold text-black">Weekly Goal</span>
                </div>
                <span className="text-sm text-black">Maintain your role with a weekly goal</span>
            </div>
            {weeklyGoalsWarning && !!weeklyGoalsWarning?.show_warning && <WeeklyGoalsWarning weeklyGoalsWarning={weeklyGoalsWarning} />}
            <GoalCard
                title={title}
                value={currentProgress}
                totalValue={targetProgress}
                type="weekly"
                isCompleted={isCompleted}
                countText={`${currentProgress}/${targetProgress}`}
            />
        </Card>
    )
}